import styled from 'styled-components';

export const colors = {
  primary: '#f8f3e6',    // Color crema suave para el fondo
  secondary: '#d4a373',  // Marrón cálido
  accent: '#6b705c',     // Verde oliva suave
  text: '#463f3a',       // Marrón oscuro para texto
  white: '#ffffff',
  shadow: 'rgba(0, 0, 0, 0.1)'
};

export const styles = {
  container: {
    padding: '2rem',
    backgroundColor: colors.primary,
    minHeight: '100vh',
  },
  
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '2rem',
    padding: '2rem',
  },
};

export const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${colors.secondary};
  color: ${colors.white};
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px ${colors.shadow};
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  
  &:hover {
    transform: scale(1.1);
    background-color: ${colors.accent};
    box-shadow: 0 6px 16px ${colors.shadow};
  }
`;
